export const printInvoiceStyles = `
  @import url('https://fonts.googleapis.com/css2?family=Cairo:wght@400;600;700&display=swap');

  :root {
    --primary: #1E88E5; /* Brand primary color (أزرق قوي) */
    --primary-light: #64b5f6; /* Lighter shade of primary */
    --text-main: #000000;
    --border-color: #000000; /* Black borders as in the screenshot */
    --white: #ffffff;
    --red: #ff0000;
    --blue: #0000cc;
  }

  body {
    font-family: 'Cairo', sans-serif;
    color: var(--text-main);
    background: var(--white);
    margin: 0;
    padding: 0;
    line-height: 1.4;
    font-size: 13px;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }

  .invoice-container {
    width: 100%;
    max-width: 800px;
    margin: 0 auto;
    padding: 20px;
    box-sizing: border-box;
  }

  /* Header */
  .invoice-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
  }

  .header-left img {
    max-height: 80px;
    max-width: 300px;
    object-fit: contain;
  }

  .header-right {
    text-align: right;
    display: flex;
    align-items: center;
    gap: 10px;
  }

  [dir="rtl"] .header-right {
    text-align: left;
  }

  .invoice-title {
    font-size: 28px;
    font-weight: 700;
    color: var(--primary);
    margin: 0;
    text-transform: uppercase;
  }

  /* Tables */
  table {
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 20px;
    border: 1px solid var(--border-color);
    page-break-inside: avoid;
    break-inside: avoid;
  }

  th, td {
    border: 1px solid var(--border-color);
    padding: 6px 10px;
    text-align: left;
  }

  [dir="rtl"] th, [dir="rtl"] td {
    text-align: right;
  }

  .text-center { text-align: center !important; }
  .text-right { text-align: right !important; }
  [dir="rtl"] .text-right { text-align: left !important; }
  
  .font-bold { font-weight: 700; }
  .text-red { color: var(--red); }
  .text-blue { color: var(--blue); }
  .text-primary { color: var(--primary); }

  /* Info Table Styles */
  .info-table th {
    background-color: var(--primary);
    color: var(--white);
    font-weight: 700;
    width: 20%;
    text-transform: uppercase;
    font-size: 12px;
  }
  
  .info-table td {
    width: 30%;
    font-weight: 600;
    font-size: 13px;
  }

  /* Items Table Styles */
  .items-table {
    page-break-inside: auto;
    break-inside: auto;
  }

  .items-table th {
    background-color: var(--primary);
    color: var(--white);
    font-weight: 700;
    text-align: center;
    text-transform: uppercase;
    font-size: 13px;
    padding: 8px 10px;
  }

  .items-table td {
    text-align: center;
    font-weight: 600;
  }

  .items-table td:nth-child(2) {
    text-align: left;
  }
  [dir="rtl"] .items-table td:nth-child(2) {
    text-align: right;
  }

  /* Footer Tables */
  .section-header {
    background-color: var(--primary);
    color: var(--white);
    font-weight: 700;
    text-align: center;
    text-transform: uppercase;
    padding: 6px;
    font-size: 14px;
    border: 1px solid var(--border-color);
  }

  .payment-table td, .bank-table td {
    font-weight: 600;
  }

  .label-cell {
    color: var(--primary);
    font-weight: 700 !important;
    width: 20%;
    background-color: transparent;
  }

  .notes-content {
    text-align: center;
    font-weight: 600;
    padding: 10px;
    background-color: transparent;
  }

  .thank-you {
    text-align: center;
    margin-top: 30px;
    font-style: italic;
    color: var(--primary);
    font-weight: 700;
    font-size: 16px;
  }
  .company-contacts {
    text-align: center;
    font-size: 12px;
    color: #333;
    margin-top: 10px;
  }
`;
